/* TuchSoft — Moodle plugin pages.
   Reading progress bar, docs table of contents, and the LLM tools.
   Nav is handled globally. */
(function () {
  var doc = document.documentElement;

  /* ---- reading progress bar --------------------------------- */
  var bar = document.getElementById('pluginProgress');
  function updateBar() {
    if (!bar) return;
    var h = doc.scrollHeight - doc.clientHeight;
    bar.style.width = (h > 0 ? (doc.scrollTop / h) * 100 : 0) + '%';
  }

  var content = document.querySelector('.docs-content');
  var heads = [];
  var links = {};

  if (content) {
    /* ---- tables: wrap for horizontal scroll ------------------ */
    [].forEach.call(content.querySelectorAll('table'), function (t) {
      if (t.parentNode && t.parentNode.classList.contains('table-wrap')) return;
      var w = document.createElement('div');
      w.className = 'table-wrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });

    /* ---- headings for the scroll-spy ------------------------- */
    [].forEach.call(content.querySelectorAll('h2, h3'), function (h) {
      var a = h.querySelector('.heading-permalink');
      if (a && a.id) heads.push({ id: a.id, el: h });
    });

    /* ---- TOC: rows, collapse toggles ------------------------ */
    var toc = document.querySelector('.table-of-contents');
    if (toc) {
      [].forEach.call(toc.querySelectorAll('li'), function (li) {
        var sub = li.querySelector(':scope > ul');
        var a = li.querySelector(':scope > a');
        if (!a || a.parentNode.classList.contains('toc__row')) return;
        var row = document.createElement('div');
        row.className = 'toc__row';
        li.insertBefore(row, a);
        if (sub) {
          li.classList.add('has-children');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'toc__toggle';
          b.setAttribute('aria-label', 'Toggle section');
          b.setAttribute('aria-expanded', 'true');
          b.addEventListener('click', function (e) {
            e.preventDefault();
            li.classList.toggle('collapsed');
            b.setAttribute('aria-expanded', String(!li.classList.contains('collapsed')));
          });
          row.appendChild(b);
        }
        row.appendChild(a);
      });
      [].forEach.call(toc.querySelectorAll('a[href^="#"]'), function (a) {
        links[a.getAttribute('href').slice(1)] = a;
      });
    }
  }

  /* ---- progress + active TOC section ------------------------ */
  var ticking = false;
  function onScroll() {
    updateBar();
    var cur = null;
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].el.getBoundingClientRect().top <= 110) cur = heads[i].id;
    }
    for (var id in links) links[id].classList.toggle('is-active', id === cur);
    ticking = false;
  }
  function requestScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }
  window.addEventListener('scroll', requestScroll, { passive: true });
  window.addEventListener('resize', requestScroll);
  onScroll();

  /* ---- mobile TOC toggle ------------------------------------ */
  var card = document.getElementById('tocCard');
  var head = document.getElementById('tocHead');
  if (card && head) {
    head.addEventListener('click', function () {
      if (window.matchMedia('(max-width: 960px)').matches) card.classList.toggle('open');
    });
  }

  /* ---- back to top ------------------------------------------ */
  [].forEach.call(document.querySelectorAll('[data-totop]'), function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      // NB: global.js redefines window.scrollTo(selector, offset), so use window.scroll.
      if (window.scroll) { window.scroll({ top: 0, behavior: 'smooth' }); }
      else { doc.scrollTop = 0; document.body.scrollTop = 0; }
    });
  });

  /* ---- "Copy for LLM" --------------------------------------- */
  var copyBtn = document.getElementById('copyMd');
  if (copyBtn) {
    var label = copyBtn.querySelector('.tool__label');
    var orig = label ? label.textContent : '';
    var busy = false;
    function flash(text, cls) {
      if (!label) return;
      label.textContent = text;
      copyBtn.classList.add(cls);
      setTimeout(function () { label.textContent = orig; copyBtn.classList.remove(cls); }, 1800);
    }
    function legacyCopy(txt) {
      var ta = document.createElement('textarea');
      ta.value = txt; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.top = '-1000px';
      document.body.appendChild(ta); ta.select();
      var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); return ok;
    }
    copyBtn.addEventListener('click', function () {
      if (busy) return; busy = true;
      fetch(copyBtn.getAttribute('data-md'), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (txt) {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(txt).then(function () { return true; },
              function () { return legacyCopy(txt); });
          }
          return Promise.resolve(legacyCopy(txt));
        })
        .then(function (ok) { flash(ok ? 'Copied!' : 'Copy failed', ok ? 'copied' : 'failed'); })
        .catch(function () { flash('Copy failed', 'failed'); })
        .then(function () { busy = false; });
    });
  }
})();
